import {useLayoutEffect} from 'react'
import getSearchParams from '../helpers/getSearchParams.js'
import getValueTrack from '../helpers/valueTrack/getValueTrack'
import {saveValueTrackCookie} from '../helpers/valueTrack'

export type ValueTrack = {
    campaignId: string
    groupId: string
    keyword: string
    platformData: PlatformData | null
}

enum Platform {
    Google = 'Google',
    Meta = 'Meta',
    Microsoft = 'Microsoft',
    Linkedin = 'Linkedin',
}

type PlatformData = {
    id: number
    platform: Platform
}

const VALUE_TRACK_LIMIT = 10

const useValueTrackSaver = () => {
    useLayoutEffect(() => {
        try {
            const searchParams = getSearchParams(window.location)
            const valueTrack = valueTrackStringFactory(searchParams)

            if (valueTrack) {
                const existingValueTracks: ValueTrack[] = getValueTrack()
                if (!existingValueTracks) {
                    saveValueTrackCookie([valueTrack])
                } else {
                    if (existingValueTracks.length >= VALUE_TRACK_LIMIT) return
                    if (
                        existingValueTracks.some(
                            (existingValueTrack) =>
                                existingValueTrack.platformData.platform === valueTrack.platformData.platform &&
                                existingValueTrack.platformData.id === valueTrack.platformData.id
                        )
                    )
                        return
                    existingValueTracks.push(valueTrack)
                    saveValueTrackCookie(existingValueTracks)
                }
            }
        } catch (e) {
            console.error(e)
        }
    }, [])
}

const getValueTrackPlatformAndLeadId = (
    googleId: number,
    metaId: number,
    microsoftId: number,
    linkedinId
): PlatformData | null => {
    if (googleId) {
        return {
            id: googleId,
            platform: Platform.Google,
        }
    }
    if (metaId) {
        return {
            id: metaId,
            platform: Platform.Meta,
        }
    }
    if (microsoftId) {
        return {
            id: microsoftId,
            platform: Platform.Microsoft,
        }
    }
    if (linkedinId) {
        return {
            id: linkedinId,
            platform: Platform.Linkedin,
        }
    }

    return null
}

const valueTrackStringFactory = (urlParams): ValueTrack | null => {
    const campaignId = urlParams.get('campaignid')
    const groupId = urlParams.get('adgroupid')
    const keyword = urlParams.get('keyword')
    const gclId = urlParams.get('gclid')
    const fbclId = urlParams.get('fbclid')
    const msclkId = urlParams.get('msclkid')
    const linkedinId = urlParams.get('li_fat_id')

    const platformData = getValueTrackPlatformAndLeadId(gclId, fbclId, msclkId, linkedinId)

    const valueTrack: ValueTrack = {campaignId, groupId, keyword, platformData}

    if (platformData) {
        return valueTrack
    }
    return null
}

export default useValueTrackSaver
